import { useEffect, useState } from 'react';

/**
 * 입력이 `delayMs` 동안 멈춘 뒤의 값 — 서버 검색어처럼 «타자마다 요청하지 않을» 값에 쓴다.
 * 업종 목록(`pages/Industries.tsx`)이 같은 형태를 제자리에 두고 있다.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
